import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeProvider } from "@/components/theme/theme-provider";
import { queryClient } from "@/lib/query-client";
import { router } from "@/router";
import { Guardian } from "@/components/errors/guardian";
import { subscribeToQueryCacheClear } from "@/lib/demo-mode";

function QueryCacheClearSubscriber() {
  useEffect(() => {
    // When demo mode toggles, clear all cached queries so they re-fetch
    // immediately with the new mode (demo data ↔ real API).
    const unsub = subscribeToQueryCacheClear(() => {
      queryClient.clear();
    });
    return unsub;
  }, []);
  return null;
}

export default function App() {
  return (
    <Guardian>
      <QueryClientProvider client={queryClient}>
        <QueryCacheClearSubscriber />
        <ThemeProvider>
          <TooltipProvider>
            <RouterProvider router={router} />
            <Toaster position="top-right" richColors closeButton />
          </TooltipProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </Guardian>
  );
}
